export const FI_ORANGE_DROP_SHADOW_CLASS = 'drop-shadow-[0px_2px_20px_rgba(255,120,23,0.66)]';
export const FI_GREY_DROP_SHADOW_CLASS = 'drop-shadow-[0px_4px_15px_rgba(0,0,0,0.25)]';

/**
 * Bubble palette (KINDLY-1079). Same asymmetric radii / padding as
 * Peersona so the two surfaces read as siblings; Fi keeps a distinct
 * light-blue assistant tone (vs Peersona's solid Kindly blue).
 */
export const FI_PANEL_BG = '#FFFFFF';

export const FI_BUBBLE_USER_BG = '#3F4858';
export const FI_BUBBLE_USER_TEXT = '#FFFFFF';
export const FI_BUBBLE_ASSISTANT_BG = '#E2ECFB';
export const FI_BUBBLE_ASSISTANT_TEXT = '#1F2A44';

/** Match PeersonaMessageBubble corner treatment. */
export const FI_USER_BUBBLE_RADII = 'rounded-tl-[20px] rounded-tr-[20px] rounded-bl-[20px] rounded-br-[4px]';
export const FI_ASSISTANT_BUBBLE_RADII = 'rounded-tl-[20px] rounded-tr-[20px] rounded-bl-[4px] rounded-br-[20px]';

export const FI_TEXT_MUTED = '#90A1B9';

export const FI_BLOB_GRADIENT = {
  x1: '26.3485',
  y1: '32.2563',
  x2: '44.7512',
  y2: '70.948',
} as const;

export const FI_BLOB_PATH =
  'M82.3409 41.6589C78.5445 64.2357 66.6065 86.6987 41.6635 82.3363C16.7205 77.9739 -4.93552 74.0365 0.986045 41.6589C6.90761 9.28136 10.1801 -3.8829 41.6635 0.981464C73.1469 5.84583 86.1373 19.0821 82.3409 41.6589Z';

export const FI_FONT_FEATURE_SETTINGS = { fontFeatureSettings: "'liga' 0" } as const;
